import SystemApi from '@/utils/Videomonster/Api/System'
import * as ConstantHelper from '../Constants'
import i18n from '@/i18n';

const _GetPrivateErrorInfo = (err) => {
    let errorInfo = {
        code: null
    }

    try {
        // err 값 자체가 null or undefined인 경우
        if (!err) {
            errorInfo.code = err
        }
        // Web Request Exception
        else if (err.response) {
            const { request, config, data } = err.response

            errorInfo.requestInfo = {}
            if (request) errorInfo.requestInfo.url = request.responseURL
            if (config) {
                if (typeof config.data === 'string') {
                    errorInfo.requestInfo.data = JSON.parse(config.data)
                }
                else {
                    errorInfo.requestInfo.data = config.data
                }
                // 개인정보보호를 위해 비밀번호는 수집하지 않음
                if (errorInfo.requestInfo.data && errorInfo.requestInfo.data.pw) delete errorInfo.requestInfo.data.pw
            }

            // 비디오몬스터 서버에서 FailedMessage를 보낸 경우
            if (data && data.error_code) {
                const { error_code: _errorCode, description } = data
                errorInfo.code = _errorCode
            }
            // 다른 API 서버에서 에러가 발생한 경우
            else if (err.response.status) {
                const { status, statusText } = err.response
                errorInfo.code = status
            }
        }
        else if (err.name) {
            if (err.name === 'Error') {
                if (err.message.includes('read-only')) {
                    errorInfo.code = 'read-only'
                } else {
                    errorInfo.code = err.message
                }
            }
            else {
                errorInfo.code = err.name
            }
        }
        else {
            // err 자체가 문자열일 경우 ex) 'CLIENT_TEMPLATE_ERROR_1'
            errorInfo.code = err
        }
        return errorInfo
    }
    catch (_err) {
        if (_err && _err.name) {
            errorInfo.code = (_err.name === 'Error') ? _err.message : _err.name
        }
        else {
            errorInfo.code = 'InternalClientError'
        }
        return errorInfo
    }
}

/**
 * Try Catch 문에서 Error 객체를 넘겨주면 PublicErrorCode를 반환
 * @param {*} err 
 * @returns string (PublicErrorCode)
 */
const _GetPublicErrorCode = (err) => {
    const { code } = _GetPrivateErrorInfo(err)
    const publicErrorCode = ConstantHelper.GetPublicErrorCode(code)
    return publicErrorCode
}

/**
 * @param {any} caller this
 * @param {string} userId 
 * @param {Error} err
 * @param {{
 *  server: boolean; 
 *  alert: boolean;
 *  log: boolean;
 * }} option 기본값은 false
 * @param {{
 *  server: string[]; 
 *  alert: string[];
 * }} excludes 제외할 PublicErrorCode 목록
 * @returns string (PublicErrorCode)
 */
const _ErrorHandler = async (caller, userId, err, option = {
    server: false, // 서버에 에러 로그 기록 여부
    alert: false, // Alert 여부
    log: false // 콘솔 Log 기록 여부
}, excludes = {
    server: [], // 서버 로그 제외할 PublicErrorCode 목록
    alert: [], // Alert 제외할 PublicErrorCode 목록
}) => {
    const { server, alert: showAlert, log: showLog } = option
    const excludesAlertList = excludes.alert ? excludes.alert : []
    const excludesServerList = excludes.server ? excludes.server : []
    try {
        const { code: privateErrorCode, requestInfo } = _GetPrivateErrorInfo(err)
        const publicErrorCode = ConstantHelper.GetPublicErrorCode(privateErrorCode)

        if (showLog) {
            console.log(`[ ERROR ] ${privateErrorCode}(${publicErrorCode})`)
            console.log(err)
        }
        if (showAlert && !excludesAlertList.includes(publicErrorCode)) {
            alert(i18n.t('global.error.message').replace(`{CODE}`, `(code ${publicErrorCode})`))
        }
        if (server && !excludesServerList.includes(publicErrorCode)) {
            let deviceInfo = {}
            const log = {
                from: 'web_editor',
                errorCode: privateErrorCode,
                publicErrorCode
            }
            if (err) {
                log.message = err.message
                log.name = err.name
                log.stack = err.stack
            }
            if (requestInfo) log.requestInfo = requestInfo
            if (navigator && navigator.userAgentData) deviceInfo = navigator.userAgentData
            if (window && window.location) log.locationInfo = window.location.href
            if (caller && caller.constructor) log.constructor = caller.constructor.name

            await SystemApi.PostAppErrorLog(userId, log, deviceInfo)
        }
        return publicErrorCode
    }
    catch (_err) {
        const { code: privateErrorCode } = _GetPrivateErrorInfo(_err)
        const subPublicErrorCode = ConstantHelper.GetPublicErrorCode(privateErrorCode)
        const publicErrorCode = ConstantHelper.PUBLIC_ERROR_CODE.INTERNAL_CLIENT_ERROR
        const outputErrorCode = `${publicErrorCode}-${subPublicErrorCode}`
        if (showLog) {
            console.log(`[ ERROR ] ${privateErrorCode}(${outputErrorCode})`)
            console.log(_err)
        }
        if (showAlert && !excludesAlertList.includes(publicErrorCode)) {
            alert(i18n.t('global.error.message').replace(`{CODE}`, `(code ${outputErrorCode})`))
        }
        return outputErrorCode
    }
}

export const GetPublicErrorCode = _GetPublicErrorCode
export const ErrorHandler = _ErrorHandler